if (!window.serlinoCartUpsellInitialized) {
  window.serlinoCartUpsellInitialized = true;

  const getCartSections = async () => {
    const response = await fetch(
      `${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`
    );

    if (!response.ok) {
      throw new Error(`Cart sections could not be loaded: ${response.status}`);
    }

    return response.json();
  };

  const renderCart = async (sectionData, productId) => {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      return;
    }

    let sections = sectionData;

    if (!sections) {
      sections = await getCartSections();
    }

    cartDrawer.renderContents({
      id: productId,
      sections
    });
  };

  const removeFailedUpsell = async (variantId) => {
    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    });
  };

  document.addEventListener('click', async (event) => {
    const addButton = event.target.closest('[data-serlino-upsell-add]');

    if (!addButton || addButton.disabled) return;

    const upsell = addButton.closest('[data-serlino-upsell]');
    const variantId = Number(upsell?.dataset.variantId);
    const discountCode = upsell?.dataset.discountCode?.trim();
    const buttonLabel = addButton.querySelector(
      '[data-upsell-button-label]'
    );

    if (!upsell || !variantId) return;

    event.preventDefault();

    const originalLabel = buttonLabel?.textContent?.trim() || 'Add';

    addButton.disabled = true;

    if (buttonLabel) {
      buttonLabel.textContent = 'Adding...';
    }

    let productAdded = false;

    try {
      const addResponse = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
             {
  id: variantId,
  quantity: 1,
  properties: {
    _serlino_cart_upsell: 'true'
  }
}
            ]
          })
        }
      );

      const addResult = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(
          addResult.description ||
            addResult.message ||
            'Product could not be added.'
        );
      }

      productAdded = true;

      let renderedSections = null;

      if (discountCode) {
        const discountResponse = await fetch(
          `${window.Shopify.routes.root}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              discount: discountCode,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          }
        );

        const discountResult = await discountResponse.json();

        if (!discountResponse.ok) {
          throw new Error(
            discountResult.description ||
              discountResult.message ||
              'Upsell discount could not be applied.'
          );
        }

        renderedSections = discountResult.sections || null;
      }

      if (buttonLabel) {
        buttonLabel.textContent = 'Added';
      }

      await renderCart(renderedSections, variantId);
    } catch (error) {
      console.error('[Serlino cart upsell]', error);

      if (productAdded && discountCode) {
        try {
          await removeFailedUpsell(variantId);
          await renderCart(null, variantId);
        } catch (rollbackError) {
          console.error(
            '[Serlino cart upsell rollback]',
            rollbackError
          );
        }
      }

      addButton.disabled = false;

      if (buttonLabel) {
        buttonLabel.textContent = originalLabel;
      }

      window.alert(
        'The product could not be added with the promotional price. Please try again.'
      );
    }
  });
  // Intelligems: the upsell takes a fixed amount off (data-ig-upsell-discount, in cents), so when the variant
  // is in a test, show test price minus that amount and recompute "Save X%". Variants not in a test keep the
  // Liquid values. Re-runs whenever the cart drawer re-renders the upsell.
  const formatIgUpsellMoney = (amount) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

  const applyIgUpsellPrices = () => {
    const api = window.igData && window.igData.price;
    if (!api || typeof api.getPriceByVariantId !== 'function') return false;

    document.querySelectorAll('[data-serlino-upsell][data-ig-upsell-discount]').forEach((upsell) => {
      const testPrice = Number(api.getPriceByVariantId(upsell.dataset.variantId));
      const discount = Number(upsell.dataset.igUpsellDiscount) / 100;
      if (!testPrice || !discount) return;

      const priceEl = upsell.querySelector('[data-ig-upsell-price]');
      const savingEl = upsell.querySelector('[data-ig-upsell-saving]');
      if (priceEl) priceEl.textContent = formatIgUpsellMoney(Math.max(testPrice - discount, 0));
      if (savingEl) savingEl.textContent = Math.round((discount / testPrice) * 100) + '%';
    });

    if (typeof window.igData.resetDom === 'function') window.igData.resetDom();
    return true;
  };

  let igUpsellAttempts = 0;
  const waitForIgUpsell = () => {
    if (!applyIgUpsellPrices() && ++igUpsellAttempts < 50) window.setTimeout(waitForIgUpsell, 200);
  };
  waitForIgUpsell();

  let igUpsellTimer = null;
  new MutationObserver((mutations) => {
    const upsellAdded = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (node.matches('[data-serlino-upsell]') || node.querySelector('[data-serlino-upsell]'))
      )
    );
    if (!upsellAdded) return;
    window.clearTimeout(igUpsellTimer);
    igUpsellTimer = window.setTimeout(applyIgUpsellPrices, 250);
  }).observe(document.body, { childList: true, subtree: true });
}

